import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { TicketQueue } from '@/components/features/tickets';

export function TicketsPage() {
  return (
    <>
      <Meta title="Support tickets" />

      <Container className="space-y-6">
        <p className="text-[12.5px] text-muted-foreground">
          Raised by labs from the Issues page of the user portal. Replies and resolutions are
          emailed to the lab.
        </p>
        <TicketQueue />
      </Container>
    </>
  );
}
